var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-outter"},[_c('div',[_c('leftArea')],1),_c('div',{staticStyle:{"margin-bottom":"110px"}},[_c('centerArea')],1),_c('div',[_c('rightArea')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }